module.exports = __webpack_public_path__ + "img/16_94.8f76d317.png";